import { Search, X } from "lucide-react";

const fieldClass =
  "bg-transparent border-b border-black/20 focus:border-[#0D0D0D] outline-none py-3 text-sm text-[#0D0D0D] placeholder:text-[#0D0D0D]/35 transition-colors duration-300";

export const AdminFilters = ({ filters, onChange, resultCount, total }) => {
  const set = (key, value) => onChange({ ...filters, [key]: value });
  const active = filters.q || filters.from || filters.to;

  return (
    <div data-testid="admin-filters" className="mb-8 flex flex-col lg:flex-row lg:items-end gap-6 lg:gap-10">
      <label className="flex-1 flex items-center gap-3 border-b border-black/20 focus-within:border-[#0D0D0D] transition-colors duration-300">
        <Search size={16} strokeWidth={1.5} className="text-[#736F6E] shrink-0" />
        <input
          data-testid="admin-search-input"
          type="search"
          placeholder="Rechercher un prénom, un nom, un email ou un téléphone…"
          value={filters.q}
          onChange={(e) => set("q", e.target.value)}
          className="w-full bg-transparent outline-none py-3 text-sm text-[#0D0D0D] placeholder:text-[#0D0D0D]/35"
        />
      </label>
      <div className="flex items-end gap-6">
        <label className="flex flex-col gap-1">
          <span className="font-mono-alt text-[10px] uppercase tracking-[0.2em] text-[#736F6E]">Du</span>
          <input data-testid="admin-date-from" type="date" value={filters.from} max={filters.to || undefined}
            onChange={(e) => set("from", e.target.value)} className={fieldClass} />
        </label>
        <label className="flex flex-col gap-1">
          <span className="font-mono-alt text-[10px] uppercase tracking-[0.2em] text-[#736F6E]">Au</span>
          <input data-testid="admin-date-to" type="date" value={filters.to} min={filters.from || undefined}
            onChange={(e) => set("to", e.target.value)} className={fieldClass} />
        </label>
        {active && (
          <button data-testid="admin-filters-reset" type="button" onClick={() => onChange({ q: "", from: "", to: "" })}
            className="flex items-center gap-1.5 pb-3 text-[11px] uppercase tracking-[0.15em] text-[#6E6A66] hover:text-[#0D0D0D] transition-colors">
            <X size={13} /> Effacer
          </button>
        )}
      </div>
      <p data-testid="admin-filter-count" className="font-mono-alt text-[10px] uppercase tracking-[0.2em] text-[#736F6E] lg:pb-3 whitespace-nowrap">
        {active ? `${resultCount} résultat${resultCount > 1 ? "s" : ""} sur ${total}` : `${total} inscription${total > 1 ? "s" : ""}`}
      </p>
    </div>
  );
};

export const applyFilters = (items, { q, from, to }) => {
  const needle = q.trim().toLowerCase();
  return items.filter((r) => {
    if (needle) {
      const hay = `${r.first_name} ${r.last_name} ${r.email} ${r.phone || ""}`.toLowerCase();
      if (!hay.includes(needle)) return false;
    }
    const day = (r.created_at || "").slice(0, 10);
    if (from && day < from) return false;
    if (to && day > to) return false;
    return true;
  });
};
